import { create } from 'zustand';

interface TerminalState {
  connected: boolean;
  sandboxId: string | null;
  outputBuffer: string[];

  // Actions
  setConnected: (connected: boolean) => void;
  setSandboxId: (id: string | null) => void;
  appendOutput: (data: string) => void;
  clearOutput: () => void;
}

export const useTerminalStore = create<TerminalState>((set) => ({
  connected: false,
  sandboxId: null,
  outputBuffer: [],

  setConnected: (connected) => set({ connected }),
  setSandboxId: (id) => set({ sandboxId: id }),
  appendOutput: (data) =>
    set((state) => ({
      outputBuffer: [...state.outputBuffer.slice(-500), data],
    })),
  clearOutput: () => set({ outputBuffer: [] }),
}));
